var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stop",
    d: "M77.536,129.713a1.6,1.6,0,1,1-2.264,2.263l-5.264-5.263-5.272,5.263a1.613,1.613,0,0,1-1.136.472,1.6,1.6,0,0,1-1.128-2.735l5.272-5.263-5.272-5.271a1.6,1.6,0,0,1,2.264-2.263l5.272,5.271,5.264-5.271a1.6,1.6,0,0,1,2.264,2.263l-5.264,5.271Z",
    transform: "translate(-62.004 -116.447)",
    fill: "#1d1d26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSign);
export default __webpack_public_path__ + "static/media/XSign.cea173aaf2df253a18ad40fa716f8915.svg";
export { ForwardRef as ReactComponent };